import React from 'react';
import { connect } from 'react-redux';
import { ModalBody } from 'reactstrap';
import SimplePie from '../script-visuals/SimplePie';
import SimpleBars from '../script-visuals/SimpleBars';
import SimpleProgress from '../script-visuals/SimpleProgress';

class AdherenceModalDashboard extends React.PureComponent {
  render() {
    const { analysis } = this.props;
    const {
      agent_transcript_confidence: confidence,
      script_completion: completion,
      text_distance_average_weighted: meanDistance,
      sections = [],
    } = analysis;

    return (
      <ModalBody className="text-center">
        <h4>Overall Scores</h4>

        <div className="d-flex">
          <SimplePie title="Transcript Confidence" value={confidence} />
          <SimplePie title="Script Completion" value={completion} />
          <SimplePie title="Overall Adherence" value={meanDistance} />
        </div>

        <hr />

        <div className="d-flex flex-wrap justify-content-around">
          {sections.map(({
            script_word_count: scriptCount,
            text_distance: distance,
            transcript_word_count: realCount,
            section_name: title,
          }) => (
            <div
              key={`ScriptModal-${distance}-${title}`}
              className="border border-gray p-2 mb-2"
              style={{ width: '45%' }}
            >
              <div>
                <SimpleProgress title="Adherence" value={distance} />
                <SimpleBars
                  title="Word Count"
                  values={[realCount, scriptCount]}
                  labels={['real', 'script']}
                  height="7rem"
                />
              </div>
            </div>
          ))}
        </div>
      </ModalBody>
    );
  }
}

const mapDispatchToProps = {
  setPanel: (panel) => ({ type: 'SET_DIFF_PANEL', panel }),
};

export default connect(null, mapDispatchToProps)(AdherenceModalDashboard);
